const setCheck = (setChecks, checkNum) => () =>
  setChecks((currentChecks) => {
    const newChecks = [...currentChecks];
    newChecks[checkNum] = !newChecks[checkNum];
    return newChecks;
  });

export default setCheck;
